module.exports = __webpack_public_path__ + "247f28a0a5da04892534d88fe471489d.png";